/**
 * Eigene, schlanke Merkliste (Wishlist) fuer mode-weiss.com.
 * Ersatz fuer die Swym-Wishlist-App (siehe Performance-Analyse 2026-09).
 *
 * Speicherung ausschliesslich im Browser (localStorage) - kein Server, kein
 * externer API-Call, kein Geraete-/Konto-Sync (bewusst so entschieden, siehe
 * Absprache). Gespeichert werden nur Produkt-Handles.
 */
(function () {
  var STORAGE_KEY = 'mode-weiss-wishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // localStorage nicht verfuegbar (z. B. Privates Surfen mit strikten Einstellungen) - ignorieren
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    var added;
    if (index === -1) {
      list.push(handle);
      added = true;
    } else {
      list.splice(index, 1);
      added = false;
    }
    saveWishlist(list);
    return added;
  }

  function updateButtonStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = list.indexOf(handle) !== -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
      var label = active
        ? button.getAttribute('data-label-remove')
        : button.getAttribute('data-label-add');
      if (label) button.setAttribute('aria-label', label);
    });
  }

  function updateCounter() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-wishlist-count-bubble]').forEach(function (wrapper) {
      // Die Klasse "wishlist-count-bubble--hidden" steuert das innere Badge-<div>
      // (nicht den umschliessenden <a data-wishlist-count-bubble>-Wrapper selbst).
      var bubble = wrapper.querySelector('.wishlist-count-bubble') || wrapper;
      bubble.classList.toggle('wishlist-count-bubble--hidden', count === 0);
    });
  }

  function handleClick(event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('wishlist:updated', function () {
    updateButtonStates();
    updateCounter();
  });

  function init() {
    updateButtonStates();
    updateCounter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ModeWeissWishlist = {
    get: getWishlist,
    isInWishlist: isInWishlist,
    toggle: toggleWishlist,
    refresh: function () {
      updateButtonStates();
      updateCounter();
    },
    STORAGE_KEY: STORAGE_KEY,
  };
})();
